module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c5eb9014d85dac0da24506f2b203e68e.png";